export const KEP_ADDRESS_REGEX = '^[a-zA-Z0-9\\._\\-]{1,64}@(:?.*\\.?kep\\.tr)$';
export const EMAIL_REGEX = '^[a-zA-Z0-9._-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\\.){1,64}[a-zA-Z]{2,63}$';
